var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeTutorial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Youtube",
    transform: "translate(-1308 -716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    transform: "translate(1308 716)",
    fill: "#faf1e0",
    stroke: "#ffd174",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(1327.001 738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61405",
    "data-name": "Path 61405",
    d: "M197.683,109.542l-5.3-2.9a.973.973,0,0,0-1.44.854v5.747a.971.971,0,0,0,1.434.857l5.3-2.848a.973.973,0,0,0,.006-1.71Zm-5.332,2.979v-4.3l3.959,2.166Zm0,0",
    transform: "translate(-183.061 -102.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61406",
    "data-name": "Path 61406",
    d: "M21.837,3.933v-.01a5.031,5.031,0,0,0-.97-2.553A3.58,3.58,0,0,0,18.5.258L18.386.245l-.038,0C15.439.029,11.047,0,11,0H11c-.044,0-4.436.029-7.371.241l-.039,0-.1.012A3.49,3.49,0,0,0,1.125,1.4,5.273,5.273,0,0,0,.163,3.91l0,.022C.154,4.006,0,5.761,0,7.522V9.168c0,1.761.155,3.515.162,3.589v.011a4.982,4.982,0,0,0,.966,2.522,3.653,3.653,0,0,0,2.45,1.1c.089.01.167.019.219.028l.051.007c1.679.16,6.944.239,7.168.242h.013c.044,0,4.436-.029,7.345-.241l.038,0,.123-.014a3.409,3.409,0,0,0,2.337-1.118,5.272,5.272,0,0,0,.962-2.507l0-.022c.007-.074.162-1.828.162-3.589V7.522c0-1.761-.155-3.515-.162-3.589ZM20.71,9.168c0,1.63-.142,3.309-.156,3.463a4.093,4.093,0,0,1-.632,1.786,2.12,2.12,0,0,1-1.522.706l-.137.015c-2.813.2-7.04.235-7.234.236-.218,0-5.406-.083-7.035-.234-.083-.014-.174-.024-.269-.035a2.411,2.411,0,0,1-1.649-.689L2.065,14.4a3.714,3.714,0,0,1-.62-1.768c-.01-.116-.156-1.815-.156-3.468V7.522c0-1.628.142-3.3.156-3.462a4.01,4.01,0,0,1,.632-1.786A2.224,2.224,0,0,1,3.63,1.538l.105-.013c2.854-.2,7.111-.235,7.264-.236s4.408.032,7.237.236l.113.013a2.309,2.309,0,0,1,1.579.715l.005.006a3.773,3.773,0,0,1,.62,1.794c.01.11.156,1.812.156,3.468Zm0,0",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeTutorial);
export default __webpack_public_path__ + "static/media/youtube-tutorial.92eae3dc.svg";
export { ForwardRef as ReactComponent };